export default {
  title: 'Job costs',
  description: "What each job costs in labour: the crew's rostered hours and the time they were actually on site, at their pay rates.",
  previousPeriod: 'Previous period',
  nextPeriod: 'Next period',
  startDate: 'Start date',
  endDate: 'End date',
  thisMonth: 'This month',
  lastMonth: 'Last month',
  site: 'Site',
  allSites: 'All sites',
  includeDrafts: 'Include draft jobs',
  exportCsv: 'Export CSV',
  groupBy: 'Group by',
  byJob: 'By job',
  byEmployee: 'By employee',

  // Summary tiles
  statPlanned: 'Planned cost',
  statPlannedHint: 'Rostered crew × job hours',
  statActual: 'On-site cost',
  statActualHint: 'Time recorded on site, during the job',
  statHours: 'Hours',
  statHoursHint: '{actual} on site',
  statJobs: 'Jobs',
  statJobsHint: '{count} crew assignments',
  exclNotCosted: 'excl. {count} not costed',

  // Table
  colJob: 'Job',
  colEmployee: 'Employee',
  colCrew: 'Crew',
  colJobs: 'Jobs',
  colRostered: 'Rostered',
  colOnSite: 'On site',
  colPlannedCost: 'Planned cost',
  colOnSiteCost: 'On-site cost',
  personOne: '{count} person',
  personOther: '{count} people',
  jobOne: '{count} job',
  jobOther: '{count} jobs',
  noCrew: 'Nobody assigned',
  notStarted: 'Not started',
  inProgress: 'In progress',
  draft: 'Draft',
  notCosted: '{count} not costed',
  showCrew: 'Show crew for {name}',
  hideCrew: 'Hide crew for {name}',
  showJobs: 'Show jobs for {name}',
  hideJobs: 'Hide jobs for {name}',
  accepted: 'Accepted',
  pending: 'Awaiting reply',

  // Empty state
  noJobsTitle: 'No jobs start in this period',
  noJobsMessage: 'Jobs are counted on the day they start. Try another date range, or include draft jobs.',

  // Notes under the table
  noteCounting: 'Counts jobs that start in this period. Crew who declined a job are left out.',
  noteBasis:
    "Rostered is each person's assigned job hours. On site is the part of those hours they were recorded on site, so arriving early or staying late isn't costed. Both are at the person's base pay rate, with no overtime loading, super, leave loading or other on-costs.",
  noteDrafts: 'Draft jobs are included.',
  noteNotCostedOne:
    "{count} crew assignment isn't costed (no pay rate, an annual salary, or a rate that couldn't be read), so the totals leave it out. Add rates on the employee's Pay tab.",
  noteNotCostedOther:
    "{count} crew assignments aren't costed (no pay rate, an annual salary, or a rate that couldn't be read), so the totals leave them out. Add rates on each employee's Pay tab.",

  // CSV
  csvFilePrefix: 'job-costs',
  csvJobId: 'jobId',
  csvJob: 'job',
  csvSite: 'site',
  csvJobStartsUtc: 'jobStartsUtc',
  csvJobStatus: 'jobStatus',
  csvEmployeeId: 'employeeId',
  csvEmployee: 'employee',
  csvAssignment: 'assignment',
  csvRosteredHours: 'rosteredHours',
  csvOnSiteHours: 'onSiteHours',
  csvCostStatus: 'costStatus',
  csvPlannedCost: 'plannedCost',
  csvOnSiteCost: 'onSiteCost',

  // Cost panel in the job editor
  panelTitle: 'Labour cost',
  panelNoCrew: 'Assign crew to this job to see what it will cost.',
  panelOpenReport: 'Open in Job costs',
  panelUpcomingNote: 'On-site cost fills in once the job starts.',
  panelLoadFailed: "Couldn't load this job's cost.",

  // Cost badge on a roster job card
  badgeTitle: 'Planned labour cost: {amount}',
  badgePartial: 'Planned labour cost: {amount}, leaving out {count} not costed',
}
